import { render, staticRenderFns } from "./UserMemberChangeRecord.vue?vue&type=template&id=e85e7f36&scoped=true&lang=pug&"
import script from "./UserMemberChangeRecord.vue?vue&type=script&lang=ts&"
export * from "./UserMemberChangeRecord.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e85e7f36",
  null
  
)

export default component.exports